export const productSettingsIds = {
    metaFields: "metaFields",
    subAndSave: "subAndSave",
    productImage: "productImage",
    breadCrumbsOptions: "breadCrumbsOptions", 
    addToCartAndBuyNowBtn: "addToCartAndBuyNowBtn",
    productPrice: "Price",
    productTitle: "Title",
    variants: "variants",
    customMessageOptions: "customMessageOptions",
    quantityAndButtonsOptions: "quantityAndButtonsOptions",
    htmlBlock: "htmlBlock",
    productDescription: "productDescription",
    shareProduct: "shareProduct",
    detail: "detail"
}